import PageHero from "@/components/feature/PageHero";
import CtaBand from "@/components/feature/CtaBand";
import { services } from "@/mocks/services";

const serviceImages: Record<string, string> = {
  production:
    "https://readdy.ai/api/search-image?query=Professional%20film%20camera%20rig%20on%20a%20cinematic%20set%20with%20warm%20lighting%2C%20production%20crew%20in%20background%2C%20high%20end%20equipment%2C%20no%20text&width=1000&height=750&seq=mango-service-production&orientation=landscape",
  programming:
    "https://readdy.ai/api/search-image?query=Modern%20tv%20studio%20with%20large%20stage%20and%20warm%20spotlights%2C%20multi%20camera%20setup%20for%20live%20show%2C%20no%20text&width=1000&height=750&seq=mango-service-programming&orientation=landscape",
  distribution:
    "https://readdy.ai/api/search-image?query=Content%20distribution%20concept%20with%20screens%20and%20media%20network%20visualization%2C%20warm%20amber%20tones%2C%20modern%20office%2C%20no%20text&width=1000&height=750&seq=mango-service-distribution&orientation=landscape",
};

export default function Services() {
  return (
    <div>
      <PageHero
        title="服务栏目"
        subtitle="覆盖影视制作、节目策划与内容发行三大核心业务，为不同类型的客户提供一体化内容解决方案。"
        image="https://readdy.ai/api/search-image?query=Cinematic%20production%20studio%20with%20warm%20orange%20lighting%20and%20equipment%2C%20professional%20media%20workspace%2C%20dark%20elegant%20atmosphere%2C%20no%20text&width=1920&height=700&seq=mango-services-hero&orientation=landscape"
        crumbs={[{ label: "服务" }]}
      />

      <nav className="sticky top-16 md:top-20 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200/80">
        <div className="container-site flex items-center gap-1 overflow-x-auto py-2">
          {services.map((s) => (
            <a
              key={s.id}
              href={`#${s.anchor}`}
              className="flex items-center gap-2 px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className={s.icon}></i>
              {s.title}
            </a>
          ))}
        </div>
      </nav>

      {services.map((s, idx) => (
        <section
          key={s.id}
          id={s.anchor}
          className={`py-14 md:py-20 scroll-mt-32 ${idx % 2 === 0 ? "bg-background-50" : "bg-secondary-50"}`}
        >
          <div className="container-site">
            <div
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center ${
                idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
                  <i className={s.icon}></i>
                  核心业务
                </span>
                <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-4">
                  {s.title}
                </h2>
                <p className="text-accent-700 font-medium mt-2 text-sm md:text-base">{s.tagline}</p>
                <p className="text-foreground-700 mt-5 leading-relaxed text-sm md:text-base">
                  {s.description}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-7">
                  {s.details.map((d) => (
                    <div
                      key={d.name}
                      className="bg-background-50 rounded-lg p-4 border border-background-200/80"
                    >
                      <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-primary-600"></i>
                        {d.name}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 mt-1.5 leading-relaxed">
                        {d.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src={serviceImages[s.id]}
                  alt={s.title}
                  title={`${s.title} - 芒果传媒服务`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <CtaBand
        title="不确定哪种服务更适合你？"
        description="把需求告诉我们，芒果传媒会为你匹配最合适的内容方案。"
      />
    </div>
  );
}